export default __webpack_public_path__ + "static/media/thumb.a0975352.png";